import { LoaderCircleIcon } from 'lucide-preact';
import { ComponentProps } from 'preact';

import { cn } from '@/lib/utils';

import { formatPrice, getCurrencySymbol } from './utils';

interface ProductPriceProps extends Omit<ComponentProps<'div'>, 'children'> {
  currency: string | null | undefined;
  price: number | null | undefined;
}

const ProductPrice = ({ currency, price, className, ...rest }: ProductPriceProps) => {
  return (
    <div
      className={cn(
        'inline-flex items-center justify-center text-center text-2xl/6 font-medium capitalize text-secondary-green',
        className,
      )}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    >
      {getCurrencySymbol(currency)}
      {price != null ? (
        formatPrice(price)
      ) : (
        <LoaderCircleIcon className="preflight preflight-svg ml-0.5 inline-block size-4 animate-spin" />
      )}
    </div>
  );
};

export default ProductPrice;
